import React, { useMemo } from 'react';
import capitalize from 'lodash/upperFirst';
import C from './RoleList.css';
import {
  COMMUNITY_MEMBERSHIP_ROLES,
  MembershipRole,
} from 'constants/community-roles';
import isEmpty from 'lodash/isEmpty';
import { Trans } from '@lingui/react';

interface RoleDetails {
  roleName: string;
  membershipRole?: MembershipRole;
  membershipRoleIndex: number;
}

export default function RoleList(p: { roles: string[] }) {
  const roleDetails = useMemo(() => {
    let roleDetails: RoleDetails[] = [];
    let maxMIdx = -1;
    for (const roleName of p.roles ?? []) {
      const membershipRoleIndex = COMMUNITY_MEMBERSHIP_ROLES.findIndex(
        (it) => it.value === roleName,
      );
      const membershipRole =
        membershipRoleIndex >= 0
          ? COMMUNITY_MEMBERSHIP_ROLES[membershipRoleIndex]
          : undefined;
      if (!membershipRole?.isDisplayed) continue;
      if (membershipRoleIndex > maxMIdx) {
        maxMIdx = membershipRoleIndex;
      }
      roleDetails.push({ roleName, membershipRoleIndex, membershipRole });
    }
    if (maxMIdx >= 0) {
      roleDetails = roleDetails.filter((r) => {
        return r.membershipRoleIndex < 0 || r.membershipRoleIndex === maxMIdx;
      });
    }
    return roleDetails;
  }, [p.roles]);

  if (isEmpty(roleDetails)) return null;

  return (
    <>
      {roleDetails.map((it) => (
        <RoleListItem key={it.roleName} role={it} />
      ))}
    </>
  );
}

export function RoleListItem(p: { role: RoleDetails }) {
  return (
    <li className={C.item}>
      {p.role.membershipRole?.label ? (
        <Trans id={p.role.membershipRole?.label.id} />
      ) : (
        capitalize(p.role.roleName)
      )}
    </li>
  );
}
